import axios from "axios";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import getUrl from "../../../../constants/urlConst";


export function ApiCarrier() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: getUrl(),
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  return {
    getCarrier: async () => {
      try {
        const response = await authAxios.get(getUrl() + "carriers");
        return response.data;
      } catch (error) {
        console.error("Error fetching carriers:", error);
        throw error;
      }
    },

    getCarrierOptions: async () => {
      try {
        const response = await authAxios.get(getUrl() + "carrierOptions");
        return response.data;
      } catch (error) {
        console.error("Error fetching carrier options:", error);
        throw error;
      }
    },

  };
}
